// Pure utility/helper functions for ProductionOrder

export const toFixedTruncate = (num, decimalPlaces = 3) => {
  if (isNaN(num) || num === null) num = 0;
  const factor = Math.pow(10, decimalPlaces);
  const truncatedNum = Math.trunc(num * factor) / factor;
  return parseFloat(truncatedNum.toFixed(decimalPlaces));
};

export const getExpiryDate = (productionDate, daysToAdd) => {
  const [day, month, year] = productionDate.split("/")?.map(Number);
  const prodDate = new Date(year, month - 1, day);
  prodDate.setDate(prodDate.getDate() + daysToAdd);
  const expiryDay = String(prodDate.getDate()).padStart(2, "0");
  const expiryMonth = String(prodDate.getMonth() + 1).padStart(2, "0");
  const expiryYear = prodDate.getFullYear();
  return `${expiryDay}/${expiryMonth}/${expiryYear}`;
};

export const modifiedWithProperPrecision = (data, pricePrecision) => {
  const result = data?.map((item) => {
    return {
      ...item,
      weight: toFixedTruncate(item?.weight, item?.uomData[0]?.stdprecision),
      totalWeight: toFixedTruncate(item?.totalWeight, item?.uomData[0]?.stdprecision),
      stock: toFixedTruncate(item?.stock, item?.uomData[0]?.stdprecision),
      total: toFixedTruncate(item?.total, pricePrecision),
    };
  });
  return result;
};
